import React from "react";
import { Image as KonvaImage } from "react-konva";
import styled from "styled-components";
import useImage from "use-image";

const StageWrapper = ({ children }) => {
  return <StyledStageWrapper>{children}</StyledStageWrapper>;
};
export default StageWrapper;

const StyledStageWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  overflow: hidden;

  @media (max-width: 991px) {

  }

  .gridStage {
    position: fixed;
    top: 0;
    left: auto;
    width: calc(100% - 320px);
    height: 100%;
    pointer-events: none;
  }

  .konva-stage {
    @media (max-width: 991px) {
      /* transform-origin: center !important; */
      padding: 30px;
    }
  }
`;
